export const BASE_URL = 'https://us-central1-arcaentretenimento.cloudfunctions.net/api/'